import React, { createContext, useContext, useState } from "react";
const VoyageContext = createContext();
export const useVoyage = () => useContext(VoyageContext);

export const VoyageProvider = ({ children }) => {
  const [voyageState, setVoyageState] = useState({
    status: true,
    countValue: "",
  });

  const updateVoyage = (updatedState) => {
    setVoyageState((prevState) => ({
      ...prevState,
      ...updatedState,
    }));
  };

  return (
    <VoyageContext.Provider value={{ voyageState, updateVoyage }}>
      {children}
    </VoyageContext.Provider>
  );
};
